import {
  DropTable1,
  DropTable2,
  DropTable3,
  DropTable6,
  DropTable7,
  DropTable8,
  DropTable14,
  DropTable15,
  DropTable16,
  DropTable19,
  DropTable20,
  DropTable21,
  DropTable25,
  DropTable26,
  DropTable27,
  DropTable29,
} from "./tables";
import { getDropperMaker, mkDrop as d, mkTableDrop as t } from "./tools";

const c = getDropperMaker("colosseum chest");

export const colosseumChests = [
  c(
    "Dewdrop Bronze Chest",
    "Dewdrop Colosseum",
    d("Gem", 20),
    d("Weapon Upgrade Stone I", 40),
    d("Armor Upgrade Stone I", 11.1),
    d("Oak Logs", 1.67, 40),
    d("Copper Ore", 1.67, 30),
    d("Copper Bar", 5, 20),
    d("Forest Villa Key", 25),
    t(DropTable1, 1),
  ),
  c(
    "Dewdrop Silver Chest",
    "Dewdrop Colosseum",
    d("Gem", 8.33),
    d("Copper Helmet", 50),
    d("Weapon Upgrade Stone II", 25),
    d("Armor Upgrade Stone II", 10),
    d("Golden Nomwich", 2),
    d("Iron Ore", 1.67, 50),
    d("Copper Bar", 2.86, 50),
    d("Jungle Logs", 2.5, 15),
    d("Bleach Logs", 10, 25),
    d("Forest Villa Key", 10),
    t(DropTable2, 1),
  ),
  c(
    "Dewdrop Gold Chest",
    "Dewdrop Colosseum",
    d("Gem", 3.33),
    d("Gem", 1.25),
    d("Golden Jam", 2),
    d("Iron Bar", 10, 15),
    d("Gold Ore", 10, 20),
    d("Potty Rolls", 2, 50),
    d("Veiny Logs", 2, 50),
    d("Iron Platebody", 25),
    d("Forest Villa Key", 5.56),
    t(DropTable3, 1),
  ),

  c(
    "Sandstone Bronze Chest",
    "Sandstone Colosseum",
    d("Gem", 9.09),
    d("Weapon Upgrade Stone II", 40),
    d("Armor Upgrade Stone II", 11.1),
    d("Goldfish", 1.67, 50),
    d("Fly", 1.67, 65),
    d("Hermit Can", 2.5, 50),
    d("Gold Ore", 1.67, 75),
    d("Gold Bar", 5, 20),
    d("Efaunt's Tomb Key", 25),
    t(DropTable6, 1),
  ),
  c(
    "Sandstone Silver Chest",
    "Sandstone Colosseum",
    d("Gem", 5),
    d("Iron Helmet", 50),
    d("Weapon Upgrade Stone III", 25),
    d("Armor Upgrade Stone III", 10),
    d("Jellyfish", 2.5, 100),
    d("Sentient Cereal", 2.5, 125),
    d("Golden Kebabs", 2),
    d("Platinum Ore", 1.67, 50),
    d("Gold Bar", 2.86, 60),
    d("Tropilogs", 2, 100),
    d("Efaunt's Tomb Key", 10),
    t(DropTable7, 1),
  ),
  c(
    "Sandstone Gold Chest",
    "Sandstone Colosseum",
    d("Gem", 2.5),
    d("Golden Meat Pie", 2),
    d("Platinum Bar", 5, 20),
    d("Dementia Ore", 10, 80),
    d("Gold Platelegs", 25),
    d("Efaunt's Tomb Key", 5.56),
    d("Bloach", 5, 150),
    d("Fruitfly", 5, 169),
    t(DropTable8, 1),
  ),

  c(
    "Chillsnap Bronze Chest",
    "Chillsnap Colosseum",
    d("Gem", 8.33),
    d("Weapon Upgrade Stone III", 40),
    d("Yellow Snowflake", 100),
    d("Armor Upgrade Stone III", 11.1),
    d("Forest Soul", 1.67, 50),
    d("Froge", 1.67, 65),
    d("Platinum Bar", 2.86, 60),
    d("Chizoar's Cavern Key", 25),
    d("Platinum Bar", 5, 20),
    t(DropTable14, 1),
  ),
  c(
    "Chillsnap Silver Chest",
    "Chillsnap Colosseum",
    d("Gem", 4.35),
    d("Gold Helmet", 50),
    d("Crabbo", 2.5, 350),
    d("Mosquisnow", 2.5, 150),
    d("Chizoar's Cavern Key", 10),
    d("Golden Ham", 2),
    d("Dementia Ore", 1.67, 100),
    d("Tundra Logs", 2, 100),
    t(DropTable15, 1),
  ),
  c(
    "Chillsnap Gold Chest",
    "Chillsnap Colosseum",
    d("Gem", 2.22),
    d("Dementia Bar", 5, 80),
    d("Dune Soul", 2.5, 400),
    d("Void Ore", 10, 120),
    d("Flycicle", 5, 150),
    d("Platinum Shins", 25),
    d("Chizoar's Cavern Key", 5.56),
    d("Golden Bread", 3.33),
    t(DropTable16, 1),
  ),

  c(
    "Astro Bronze Chest",
    "Astro Colosseum",
    d("Gem", 8.33),
    d("Weapon Upgrade Stone IV", 66.7),
    d("Lost Batteries", 50),
    d("Armor Upgrade Stone IV", 25),
    d("Rooted Soul", 1.67, 250),
    d("Pingy", 1.67, 200),
    d("Void Bar", 2.86, 100),
    d("Troll's Enclave Key", 167),
    t(DropTable19, 1),
  ),
  c(
    "Astro Silver Chest",
    "Astro Colosseum",
    d("Gem", 4.35),
    d("Weapon Upgrade Stone IV", 25),
    d("Armor Upgrade Stone IV", 14.3),
    d("Dung Beat", 2.5, 600),
    d("Worker Bee", 2.5, 1500),
    d("Troll's Enclave Key", 83.3),
    d("Golden Ribs", 2),
    d("Lustre Ore", 1.67, 1000),
    d("Alien Hive Chunk", 2, 750),
    t(DropTable20, 1),
  ),
  c(
    "Astro Gold Chest",
    "Astro Colosseum",
    d("Gem", 2.22),
    d("Lustre Bar", 20, 150),
    d("Starfire Ore", 33.3, 2000),
    d("Fairy", 50, 1500),
    d("Troll's Enclave Key", 25),
    d("Golden Ribs", 40, 2),
    t(DropTable21, 1),
  ),

  c(
    "Molten Bronze Chest",
    "Molten Colosseum",
    d("Gem", 8.33),
    d("Weapon Upgrade Stone V", 66.7),
    d("Royal Suggma Urn", 50),
    d("Armor Upgrade Stone V", 25),
    d("Gold Food Coupon", 1.01, 4),
    d("Golden Grilled Cheese Nomwich", 4, 15),
    d("Frigid Soul", 1.67, 450),
    t(DropTable25, 1),
  ),
  c(
    "Molten Silver Chest",
    "Molten Colosseum",
    d("Gem", 4.35),
    d("Weapon Upgrade Stone V", 25),
    d("Armor Upgrade Stone V", 14.3),
    d("Scarab", 2.5, 1500),
    d("Gold Food Coupon", 1.01, 9),
    d("Golden Kebabs", 4, 40),
    d("Starfire Ore", 1.67, 5000),
    d("Maple Logs", 2, 2500),
    t(DropTable26, 1),
  ),
  c(
    "Molten Gold Chest",
    "Molten Colosseum",
    d("Gem", 2.22),
    d("Dreadlo Bar", 20, 300),
    d("Dreadlo Ore", 33.3, 3000),
    d("Dust Mote", 50, 1500),
    d("Gold Food Coupon", 1.01, 12),
    d("Golden Brad", 4, 100),
    d("Golden Kebabs", 4, 40),
    t(DropTable27, 1),
  ),

  c(
    "Whimsical Bronze Chest",
    "Whimsical Colosseum",
    d("Gem", 8.33),
    d("Weapon Upgrade Stone VI", 66.7),
    d("Stacked Rice Cake", 10, 3),
    d("Armor Upgrade Stone VI", 25),
    d("Gold Food Coupon", 1.01, 15),
    d("Golden Nigiri", 4, 60),
    d("Squishy Soul", 1.67, 1450),
    d("Oozie Soul", 1.67, 1450),
    t(DropTable29, 1),
  ),
  c(
    "Whimsical Silver Chest",
    "Whimsical Colosseum",
    d("Gem", 4.35),
    d("Weapon Upgrade Stone VI", 25),
    d("Armor Upgrade Stone VI", 14.3),
    d("Ladybug", 2.5, 1500),
    d("Gold Food Coupon", 1.01, 30),
    d("Golden Kebabs", 4, 200),
    d("Bamboo Logs", 2, 12500),
    t(DropTable29, 1),
  ),
  c(
    "Whimsical Gold Chest",
    "Whimsical Colosseum",
    d("Gem", 2.22),
    d("Godshard Bar", 20, 1000),
    d("Godshard Ore", 33.3, 30000),
    d("Firefly", 50, 1500),
    d("Gold Food Coupon", 1.01, 50),
    d("Golden Jam", 40, 320),
    d("Golden Kebabs", 4, 150),
    t(DropTable29, 1),
  ),
];
